/* nx-motion-compare.js — сравнението „4 неща" (D).
   Превключвателят работи и без GSAP (делегирани слушатели); демото е веднъж, когато секцията стигне екрана:
   колона А се оцветява, плъзгачът минава, редовете се превъртат един по един. Клик или стрелка → край на демото. */
(function () {
  if (window.__nxCmp) return; window.__nxCmp = true;
  var ROOT = '[data-nx="cmpx"]';

  function $$(root, sel) { return Array.prototype.slice.call(root.querySelectorAll(sel)); }

  /* същата логика като в devices.js, плюс tabindex за стрелките */
  function setSide(root, side) {
    root.classList.toggle('is-b', side === 'b');
    $$(root, '.cmpx-tab').forEach(function (t) {
      var on = t.getAttribute('data-side') === side;
      t.classList.toggle('is-on', on);
      t.setAttribute('aria-selected', on ? 'true' : 'false');
      t.tabIndex = on ? 0 : -1;
    });
    $$(root, '.cmpx-v').forEach(function (v) { v.classList.toggle('is-on', v.classList.contains('cmpx-' + side)); });
  }
  /* човекът пое контрола: демото отива в края си или изобщо не тръгва */
  function takeOver(root) { root.__nxTouched = true; if (root.__nxSkip) root.__nxSkip(); }
  function tabOf(e) { return e.target && e.target.closest ? e.target.closest(ROOT + ' .cmpx-tab') : null; }

  document.addEventListener('click', function (e) {
    var tab = tabOf(e);
    if (!tab) return;
    var root = tab.closest(ROOT);
    takeOver(root);
    setSide(root, tab.getAttribute('data-side'));
  }, { passive: true });

  /* ← → Home End по табовете; не е passive — стрелките иначе скролват страницата */
  document.addEventListener('keydown', function (e) {
    var k = e.key;
    if (k !== 'ArrowLeft' && k !== 'ArrowRight' && k !== 'Home' && k !== 'End') return;
    var tab = tabOf(e);
    if (!tab) return;
    var root = tab.closest(ROOT), tabs = $$(root, '.cmpx-tab'), i = tabs.indexOf(tab);
    var j = k === 'Home' ? 0 : k === 'End' ? tabs.length - 1 : (i + (k === 'ArrowRight' ? 1 : -1) + tabs.length) % tabs.length;
    e.preventDefault();
    takeOver(root);
    setSide(root, tabs[j].getAttribute('data-side'));
    tabs[j].focus();
  });

  if (!window.NX || !window.gsap) return;
  var gsap = window.gsap, ST = window.ScrollTrigger;

  window.NX.register('cmpx', ROOT, function (root, flags) {
    var motion = flags ? !!flags.motion : !matchMedia('(prefers-reduced-motion: reduce)').matches;
    if (!motion || !ST || root.__nxTouched || root.classList.contains('is-b')) return;
    var thumb = root.querySelector('.cmpx-thumb');
    var as = $$(root, '.cmpx-row .cmpx-a'), bs = $$(root, '.cmpx-row .cmpx-b');
    if (!thumb || !as.length || as.length !== bs.length) return;
    var tl, ctx, st;

    function finish() {
      /* А вече е извън кадър; чистим inline стиловете без преходи, класовете казват Б */
      gsap.set(as, { opacity: 0 });
      gsap.set(as.concat(bs), { clearProps: 'transform,opacity' });
      gsap.set(thumb, { clearProps: 'transform' });
      root.style.removeProperty('--nx-tint');
      void root.offsetWidth;
      root.classList.remove('is-nx-demo');
    }
    function build() {
      root.classList.add('is-nx-demo');
      gsap.set(as.concat(bs), { opacity: 1 });
      gsap.set(as, { yPercent: 0 });
      gsap.set(bs, { yPercent: 100 });
      tl = gsap.timeline({ delay: .25, onComplete: finish });
      tl.fromTo(root, { '--nx-tint': 0 }, { '--nx-tint': 1, duration: .4, ease: 'power1.out' }, 0)
        .call(function () { setSide(root, 'b'); }, null, .8)
        .fromTo(thumb, { xPercent: 0 }, { xPercent: 100, duration: .45, ease: 'power3.inOut' }, .8)
        .to(as, { yPercent: -100, duration: .45, ease: 'power3.inOut', stagger: .09 }, 1.05)
        .to(bs, { yPercent: 0, duration: .45, ease: 'power3.inOut', stagger: .09 }, 1.05);
    }
    root.__nxSkip = function () {
      if (tl) { if (tl.progress() < 1) tl.progress(1); }
      else if (st) st.kill();
    };

    ctx = gsap.context(function () {
      st = ST.create({ trigger: root, start: 'clamp(top 65%)', once: true, onEnter: function () {
        if (root.__nxTouched || tl) return;
        ctx.add(build);
      } });
    }, root);
    return function () {
      ctx.revert();
      root.classList.remove('is-nx-demo');
      root.style.removeProperty('--nx-tint');
      delete root.__nxSkip;
    };
  });
})();
